const FlightSeatPreferences = [
  {
    value: 'NSSA',
    label: 'No smoking aisle seat',
  },
  {
    value: 'NSSB',
    label: 'No smoking bulkhead seat',
  },
  {
    value: 'NSSR',
    label: 'No smoking rear facing seat',
  },
  {
    value: 'NSST',
    label: 'No smoking seat',
  },
  {
    value: 'NSSW',
    label: 'No smoking window seat',
  },
  {
    value: 'ASAD',
    label: 'PSS SEAT',
  },
  {
    value: 'SMSA',
    label: 'Smoking Aisle Seat',
  },
  {
    value: 'SMSB',
    label: 'Smoking Bulkhead Seat',
  },
  {
    value: 'SMSR',
    label: 'Smoking Rear Facing Seat',
  },
  {
    value: 'SMST',
    label: 'Smoking Seat',
  },
  {
    value: 'SMSW',
    label: 'Smoking Window Seat',
  },
  {
    value: 'SEAT',
    label: 'pre-reserved seat request',
  },
];

export default FlightSeatPreferences;
